// Saved reel position for resuming the exact video after back-navigation.
// sessionStorage survives React Router back-navigation (component remounts),
// which a location.state push cannot cover for browser/back-button flows.
const KEY = "reel.restorePosition";

export const saveReelPosition = (source, id, index) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ source, id, index }));
  } catch {
    // ponytail: storage unavailable (private mode) — restore is best-effort only.
  }
};

// Read-only check — lets a surface page through a paginated feed until the
// saved item is loaded before consuming the record.
export const peekReelPosition = (source) => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || data.source !== source) return null;
    return data;
  } catch {
    return null;
  }
};

// Removes the record only when it belongs to `source`, so each reel surface
// restores its own position and never consumes another surface's record.
export const consumeReelPosition = (source) => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || data.source !== source) return null;
    sessionStorage.removeItem(KEY);
    return data;
  } catch {
    return null;
  }
};

export default saveReelPosition;
